import { Component, Input } from '@angular/core';

import { EventRead } from '../../shared/event-read.model';
import { EventDateTimeDto } from '../../shared/new/eventDateTime.model';
import { ProfileMin } from '../../../profiles/shared/profile-min.model';

import { UtilService } from '../../../shared/index';
import { EventV4TypeService } from '../../shared/event-type/event-v4-type.service';
import { Image } from 'src/app/config/shared/image/image.model';

@Component({
  selector: 'wl-event-v4-settings-general',
  templateUrl: 'event-v4-settings-general.component.html',
  styleUrls: ['event-v4-settings-general.component.css'],
  providers: [EventV4TypeService],
    standalone: false
})
export class EventV4SettingsGeneralComponent {
  public _event: EventRead = new EventRead();
  public eventTypes: Array<string>;

  private _showEditor = false;
  @Input() public get showEditor() {
    return this._showEditor;
  }
  set showEditor(value: boolean) {
    this._showEditor = value;
  }

  @Input() public get event(): EventRead {
    return this._event;
  }
  public set event(value: EventRead) {
    if (this._utilService.isNotNullOrUndefined(value)) {
      this._event = value;

      this.event.DisplaySeparateHours = !value.IsAllDay && value.EventDateTimes?.length > 0;
    }
  }

  get showStartEndTime(): boolean {
    return !this.event.DisplaySeparateHours && !this.event.IsAllDay;
  }

  get showSeparateHoursCheckbox(): boolean {
    return !this.event.IsAllDay && !this.startDateIsEqualToEndDate();
  }

  get showSeparateHoursSection(): boolean {
    return this.event.DisplaySeparateHours && !this.event.IsAllDay;
  }

  public constructor(private _utilService: UtilService, private _eventTypeService: EventV4TypeService) {
    this.eventTypes = new Array<string>();
  }

  ngOnInit() {
    this._eventTypeService.getEventTypes().then((data: Array<string>) => {
      this.eventTypes = data;
    });
  }

  public eventProfileChanged = (profile: ProfileMin): void => {
    this.event.Venue = profile.ReportName;
    this.event.Address1 = profile.Address1;
    this.event.Address2 = profile.Address2;
    this.event.City = profile.City;
    this.event.State = profile.State;
    this.event.Zip = profile.Zip;
    this.event.Phone = profile.WorkPhone;
  };

  public startDateChanged(newDate: Date): void {
    if (this.event.EndDate === null) {
      this.event.EndDate = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
    }

    if (newDate !== null) {
      this.event.StartDate = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
    }

    this.endDateChanged();
  }

  public endDateChanged(): void {
    if (this.event.EndDate) {
      this.event.EndDate = new Date(this.event.EndDate.getFullYear(), this.event.EndDate.getMonth(), this.event.EndDate.getDate());
    } else {
      this.event.DisplaySeparateHours = false;
      return;
    }

    if (!this.isValidDateRange()) {
      this.event.DisplaySeparateHours = false;
      return;
    }

    this.updateEventDates();
  }

  public startDateIsEqualToEndDate(): boolean {
    if (this.event.StartDate === null || this.event.EndDate === null) {
      this.event.DisplaySeparateHours = false;
      return false;
    }

    return this._utilService.datesAreEqual(this.event.StartDate, this.event.EndDate);
  }

  public setHoursSeparatelyChanged(checkboxEvent: { checked: boolean }): void {
    if (checkboxEvent.checked) {
      this.clearStarEndTimes();
    }
  }

  public allDayChanged(checkboxEvent: { checked: boolean }): void {
    if (checkboxEvent.checked) {
      this.event.DisplaySeparateHours = false;
    } else {
      this.clearStarEndTimes();
    }
  }

  private clearStarEndTimes(): void {
    this.event.StartTime = '';
    this.event.EndTime = '';
  }

  private isValidDateRange(): boolean {
    return this.event.StartDate && this.event.EndDate && !this.startDateIsEqualToEndDate();
  }

  private updateEventDates(): void {
    const currentDateTimes = this.event.EventDateTimes;
    this.event.EventDateTimes = [];

    let currentDate = new Date(this.event.StartDate.getFullYear(), this.event.StartDate.getMonth(), this.event.StartDate.getDate());
    const endDate = new Date(this.event.EndDate.getFullYear(), this.event.EndDate.getMonth(), this.event.EndDate.getDate());

    while (currentDate <= endDate) {
      const existingDateTime = currentDateTimes.find((dt) => this._utilService.datesAreEqual(new Date(dt.EventDate), currentDate));

      if (existingDateTime) {
        this.event.EventDateTimes.push({
          EventDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()),
          StartTime: existingDateTime.StartTime,
          EndTime: existingDateTime.EndTime,
          EventDateTimeId: existingDateTime.EventDateTimeId,
          EventID: existingDateTime.EventID,
        });
      } else {
        this.event.EventDateTimes.push({
          EventDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()),
          StartTime: '',
          EndTime: '',
        } as EventDateTimeDto);
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  public eventImageChanged($event: Image) {
    if ($event.AbsolutePath) {
      this.event.ImageUrl = $event.AbsolutePath;
    }
  }
}
